import { Component, OnInit, ViewChild, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';

import { MessagesService, PortalProveedorService } from '../../../services/api.services';
import { IssueFront } from '../../../models/api.models';

import { IssueReviewPresaleData } from '../issue.review.presale.data';
import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { IssueImageComponent } from '../../shared/issue-image/issue-image.component';

@Component({
  selector: 'app-issues-repasos-preventa-escritorio',
  templateUrl: './issues-repasos-preventa-escritorio.component.html',
  styleUrls: ['./issues-repasos-preventa-escritorio.component.scss'],
})
export class IssuesRepasosPreventaEscritorioComponent implements OnInit, OnDestroy {

  @ViewChild(DatatableComponent) table: DatatableComponent;

  @Input() issueReviewPresaleData: IssueReviewPresaleData;
  @Output() rowSelected = new EventEmitter();
  @Output() giveMeIssues = new EventEmitter();


  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  selected = [];
  rows: IssueFront[] = [];

  resetRowsSelectedSubscription: Subscription;

  constructor(private modalCtrl: ModalController,
              private messages: MessagesService,
              private portalProveedorService: PortalProveedorService) {

  }
  ngOnDestroy(): void {
    if (this.resetRowsSelectedSubscription) {
      this.resetRowsSelectedSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
      if (this.issueReviewPresaleData != null) {
        this.rows = this.issueReviewPresaleData.issuesFront;
      }
      this.resetRowsSelectedSubscription = this.portalProveedorService.issuesReviewResetRowsSelectedEvent.subscribe(resp => {
        this.selected = [];
      });
    });
  }

  setPage(pageInfo) {
    this.issueReviewPresaleData.page.offset = pageInfo.offset;
    const envio = {
      page: this.issueReviewPresaleData.page,
      total: this.issueReviewPresaleData.page.count
    };
    this.giveMeIssues.emit(envio);
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    if (this.selected.length !== 0) {
      this.rowSelected.emit(this.selected);
    } else {
      this.rowSelected.emit(false);
    }
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  async openIssueImage(ev: Event, row: IssueFront) {
    const modalCtrl = await this.modalCtrl.create({
      component: IssueImageComponent,
      componentProps: {
        issueFront: row,
      }
    });
    return await modalCtrl.present();
  }

  getRowIndex(row: any): number {
    let num = -1;
    this.rows.forEach((issue, k) => {
      if (issue.id === row.id) {
        num = k;
        return;
      }
    });
    return num;
  }

  getHeaderClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };

  }

  getCellClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };
  }
}
